import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-zahlstam-list-view',
  imports: [],
  templateUrl: './zahlstam.list-view.html',
  styleUrls: ['./zahlstam.list-view.css'],
})
export class ZahlstamListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
